var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('header',{class:_vm.$style.header},[_c('JumpcloudBrandmark',{attrs:{"scale":2,"type":"jcLogoWordmark"}}),_c('ButtonClose',{on:{"click":_vm.handleClose}})],1),_c('div',[(_vm.setupFlow === 'device')?_c('DeviceSetup',{attrs:{"defaultOs":_vm.defaultDevice},on:{"close":_vm.handleClose}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }